import { createRouter, createWebHashHistory } from 'vue-router';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { auth, authPersistenceReady } from './firebaseConfig';
import { getStoredRoleForUser, saveStoredRole } from './lib/authRoleCache';
import Login from './components/LoginComponent.vue';
import AdminDashboard from './components/gestione/AdminDashboard.vue';
import AssistenzaTecnica from './components/gestione/AssistenzaTecnica.vue';
import RecuperoAccountDoppi from './components/gestione/RecuperoAccountDoppi.vue';

import AssistenzaTecnica_nascosto_risposti from './components/gestione/AssistenzaTecnica_nascosto_risposti.vue';
import AssistenzaTecnica_nascosto_ricerca from './components/gestione/AssistenzaTecnica_nascosto_ricerca.vue';

import UserDashboard from './components/utenti/UserDashboard.vue';
import CreateTicket from '@/components/utenti/CreateTicket.vue';
import CreateTicketTecnico from '@/components/utenti/CreateTicketTecnico.vue';
import AdminTicketConversation from '@/components/gestione/AdminTicketConversation.vue';
import AssistenzaTecnicaConversation from '@/components/gestione/AssistenzaTecnicaConversation.vue';
import UserTicketConversation from '@/components/utenti/UserTicketConversation.vue';
import UserTicketConversationTecnico from '@/components/utenti/UserTicketConversationTecnico.vue';
import RicettaComponent from './components/utenti/RicettaComponent.vue';
import TicketsRisposti from './components/gestione/TicketsRisposti.vue';
import CreateUsers from './components/CreateUsers.vue';
import VideoCall from './components/utenti/VideoCall.vue';
import VideoCallPage from './components/utenti/VideoCallPage.vue';
import UserAnagrafica from './components/utenti/UserAnagrafica.vue';
import TicketPage from './components/utenti/TicketPage.vue';
import TicketPageTecnico from './components/utenti/TicketPageTecnico.vue';
import OrdersComponent from './components/utenti/OrdersComponent.vue';
import AlimentazionePage from './components/utenti/AlimentazionePage.vue';
import ComeFunzionaMobile from './components/utenti/ComeFunzionaMobile.vue';
import UserServices from './components/utenti/UserServices.vue';
import GiftOrder from './components/utenti/GiftOrder.vue';

import ProgrammiUser from './components/utenti/ProgrammiUser.vue';
import ProgrammiUserQuestionario from './components/utenti/ProgrammiUserQuestionario.vue';
import ProgrammiUserCheckFinale from './components/utenti/ProgrammiUserCheckFinale.vue';


import UserCheckStorico from './components/utenti/UserCheckStorico.vue';

import UserBooking from './components/utenti/UserBooking.vue';
import OrdersGeneral from './components/studio/OrdersGeneral.vue';
import GestioneGeneral from './components/studio/GestioneGeneral.vue';
import PublicBookingsList from './components/studio/PublicBookingsList.vue';


import CreateOrder from './components/studio/CreateOrder.vue';

import PayPalReturn from './components/paypal/PayPalReturn.vue'
import PayPalCancel from './components/paypal/PayPalCancel.vue'
import PublicCheckout from './components/checkout/PublicCheckout.vue'
import PublicBooking from './components/booking/PublicBooking.vue'


import OrderSummary from './components/studio/OrderSummary.vue';
import BookingGeneral from './components/studio/BookingGeneral.vue';
import DashboardGeneral from './components/gestione/DashboardGeneral.vue';
import CalendariEventi from './components/gestione/CalendariEventi.vue';
import ProductList from './components/gestione/ProductList.vue';
import OrderList from './components/gestione/OrderList.vue';
import OrderComponent from './components/gestione/OrderComponent.vue';
import OrderComponentNew from './components/gestione/OrderComponentNew.vue';
import OrdersAnalytics from './components/gestione/OrdersAnalytics.vue';
import OrdersAccounting from './components/gestione/OrdersAccounting.vue';
import ManualInstallments from './components/gestione/ManualInstallments.vue';
import PtOrdersExport from './components/gestione/PtOrdersExport.vue';
import ProdottiAcquistati from './components/gestione/ProdottiAcquistati.vue';
import AcquirentiProdottiLista from './components/gestione/AcquirentiProdottiLista.vue';
import LinkClicksAnalytics from './components/gestione/LinkClicksAnalytics.vue';

import QuestionariTemplatesAdmin from './components/studio/QuestionariTemplatesAdmin.vue';
import QuestionariUsers from './components/gestione/QuestionariUsers.vue';
import QuestionariUsersScaduti from './components/gestione/QuestionariUsersScaduti.vue';
import QuestionariManuali from './components/gestione/QuestionariManuali.vue';


import UsciteComponent from './components/gestione/UsciteComponent.vue';
import UsersList from './components/gestione/UsersList.vue';
import UsersInfluencerList from './components/gestione/UsersInfluencerList.vue';
import UsersTopList from './components/gestione/UsersTopList.vue';
import UsersExpiringList from './components/gestione/UsersExpiringList.vue';
import BackfillTopSku from './components/gestione/BackfillTopSku.vue';
import ContattiList from './components/gestione/ContattiList.vue';
import CampagnaIntegrazione from './components/gestione/CampagnaIntegrazione.vue';
import RiContattiUtenti from './components/gestione/RiContattiUtenti.vue';
import ProcedureComponent from './components/gestione/ProcedureComponent.vue';
import PrivacyAcceptedUsers from './components/gestione/PrivacyAcceptedUsers.vue';
import CampagnaIntegrazioneFc3 from './components/gestione/CampagnaIntegrazioneFc3.vue';
import UserDetails from './components/gestione/UserDetails.vue';
import UserOrdini from './components/gestione/UserOrdini.vue';
import UserComunicazioni from './components/gestione/UserComunicazioni.vue';
import UserConsulenze from './components/gestione/UserConsulenze.vue';
import UserConsulenzeRiepilogo from './components/gestione/UserConsulenzeRiepilogo.vue';

import UserDocumenti from './components/gestione/UserDocumenti.vue';
import UserCheck from './components/gestione/UserCheck.vue';
import UserCheckCreate from './components/gestione/UserCheckCreate.vue';

import UsersTicketNutrizionali from './components/gestione/UsersTicketNutrizionali.vue';
import UserTicketTecnici from './components/gestione/UserTicketTecnici.vue';
import UserAlimentazione from './components/gestione/UserAlimentazione.vue';
import UserProgrammi from './components/gestione/UserProgrammi.vue';
import UserProgrammiQuestionario from './components/gestione/UserProgrammiQuestionario.vue';
import UserProgrammiCheckFinale from './components/gestione/UserProgrammiCheckFinale.vue';
import QuestionariUidFix from './components/gestione/QuestionariUidFix.vue';
import ConsulenzeTecnicheScalataTool from './components/gestione/ConsulenzeTecnicheScalataTool.vue';
import PercorsiNonIniziati from './components/gestione/PercorsiNonIniziati.vue';
import ImportProgramHistory from './components/gestione/ImportProgramHistory.vue';
import UserSedutePt from './components/gestione/UserSedutePt.vue';
import UserLayout from '@/layouts/UserLayout.vue';
import VideocallList from './components/gestione/VideocallList.vue';
import VideocallListBooking from './components/gestione/VideocallListBooking.vue';
import PageNoAccess from './components/gestione/PageNoAccess.vue';
import BookingsList from './components/gestione/BookingsList.vue';
import InviiComponent from './components/gestione/InviiComponent.vue';
import InviiDaModificareComponent from './components/gestione/InviiDaModificareComponent.vue';
import InviiComponent_archivio from './components/gestione/InviiComponent_archivio.vue';

import CheckComponent from './components/gestione/CheckComponent.vue';
import ListaContatti from './components/gestione/ListaContatti.vue';

import PromemoriaPubblico from './components/gestione/PromemoriaPubblico.vue';
import RecuperoTicketDoppi from './components/gestione/RecuperoTicketDoppi.vue';
import ImportOrders from './components/gestione/ImportOrders.vue';
import Notifiche10Giorni from './components/gestione/Notifiche10Giorni.vue';
import Notifiche24Giorni from './components/gestione/Notifiche24Giorni.vue';
import Notifiche40Giorni from './components/gestione/Notifiche40Giorni.vue';
import Notifiche45Giorni from './components/gestione/Notifiche45Giorni.vue';



import RicontattiComponent from './components/gestione/RicontattiComponent.vue';




// Funzione che restituisce una promise risolta quando Firebase ha determinato lo stato dell'utente
async function getCurrentUser() {
  await authPersistenceReady;
  if (auth.currentUser) {
    return auth.currentUser;
  }

  return new Promise((resolve, reject) => {
    let removeListener = () => {};
    const timeoutId = window.setTimeout(() => {
      removeListener();
      resolve(auth.currentUser);
    }, 10000);

    removeListener = auth.onAuthStateChanged(user => {
      window.clearTimeout(timeoutId);
      removeListener();
      resolve(user);
    }, error => {
      window.clearTimeout(timeoutId);
      removeListener();
      reject(error);
    });
  });
}

const routes = [
  { path: '/', component: Login },
  { path: '/noaccess', name: 'PageNoAccess', component: PageNoAccess },
  { path: '/admin', component: AdminDashboard, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/assistenzatecnica', component: AssistenzaTecnica, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/recuperoaccountdoppi', component: RecuperoAccountDoppi, meta: { requiresRole: ['Amministratore'] } },
  { path: '/recuperoticketdoppi', component: RecuperoTicketDoppi, meta: { requiresRole: ['Amministratore'] } },

  { path: '/assistenzatecnica-nascosta', component: AssistenzaTecnica_nascosto_risposti, meta: { requiresRole: ['Amministratore'] } },
  { path: '/assistenzatecnica-nascosta-ricerca', component: AssistenzaTecnica_nascosto_ricerca, meta: { requiresRole: ['Amministratore'] } },

  { path: '/ticketsrisposti', component: TicketsRisposti, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/dashboard', component: DashboardGeneral, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/products', component: ProductList, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/users-list', component: UsersList, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/users-influencer-list', component: UsersInfluencerList, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/users-top-list', component: UsersTopList, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/users-expiring-list', component: UsersExpiringList, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/backfill-top-sku', component: BackfillTopSku, meta: { requiresRole: ['Amministratore'] } },
  { path: '/invii-giornata', component: InviiComponent, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/invii-da-modificare', component: InviiDaModificareComponent, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/invii-giornata-archivio', component: InviiComponent_archivio, meta: { requiresRole: ['Amministratore'] } },

  { path: '/check-dafare', component: CheckComponent, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/lista-contatti', component: ListaContatti, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/promemoria-pubblico', component: PromemoriaPubblico, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/notifiche-10-giorni', component: Notifiche10Giorni, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/notifiche-24-giorni', component: Notifiche24Giorni, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/notifiche-40-giorni', component: Notifiche40Giorni, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  {
    path: '/programmi-da-oscurare',
    alias: '/notifiche-45-giorni',
    component: Notifiche45Giorni,
    meta: { requiresRole: ['Amministratore', 'Studio'] }
  },
  { path: '/import-orders', component: ImportOrders, meta: { requiresRole: ['Amministratore'] } },



  { path: '/ricontatti', component: RicontattiComponent, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/contatti-list', component: ContattiList, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/campagna-integrazione', component: CampagnaIntegrazione, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/ricontatti-utenti', component: RiContattiUtenti, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/procedure', component: ProcedureComponent, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/privacy-accepted', component: PrivacyAcceptedUsers, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/campagna-integrazione-fc3', component: CampagnaIntegrazioneFc3, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/orders-user/:orderId', component: OrdersComponent, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/gift', alias: '/gift-fc1-plus', component: GiftOrder, meta: { requiresAuth: true } },
  { path: '/orders-general', component: OrdersGeneral, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/prenotazioni-pubbliche', component: PublicBookingsList, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/gestione-general', component: GestioneGeneral, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/monitoraggio-percorsi', name: 'ProgrammeMonitor', component: () => import('./components/gestione/ProgrammeMonitor.vue'), meta: { requiresAuth: true, requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/allenamenti-basi', name: 'TrainingBases', component: () => import('./features/allenamenti/TrainingBases.vue'), meta: { requiresAuth: true, requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/allenamenti-catalogo', name: 'TrainingMediaCatalog', component: () => import('./features/allenamenti/TrainingMediaCatalog.vue'), meta: { requiresAuth: true, requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/allenamenti-basi/:baseId', name: 'TrainingBaseEditor', component: () => import('./features/allenamenti/TrainingBaseEditor.vue'), meta: { requiresAuth: true, requiresRole: ['Amministratore', 'Studio'] } },


    { path: '/paypal/return', component: PayPalReturn, meta: { requiresAuth: true } },
    { path: '/paypal/cancel', component: PayPalCancel, meta: { requiresAuth: false } },
    { path: '/checkout', name: 'PublicCheckout', component: PublicCheckout },
    { path: '/checkout/success', name: 'PublicCheckoutSuccess', component: PublicCheckout },
    { path: '/checkout/cancel', name: 'PublicCheckoutCancel', component: PublicCheckout },
    { path: '/prenota', name: 'PublicBooking', component: PublicBooking },
    { path: '/prenota/success', name: 'PublicBookingSuccess', component: PublicBooking },





  { path: '/booking-general', component: BookingGeneral, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/create-order', component: CreateOrder, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/order-summary', component: OrderSummary, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/order-list', component: OrderList, meta: { requiresRole: ['Amministratore', 'Spedizioni', 'Studio'] } },
  { path: '/order', component: OrderComponent, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/order-list-new', component: OrderComponentNew, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/orders-analytics', component: OrdersAnalytics, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/link-click-analytics', component: LinkClicksAnalytics, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/orders-accounting', component: OrdersAccounting, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/rate-manuali', component: ManualInstallments, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/ordini-pt-export', component: PtOrdersExport, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/prodotti-acquistati', component: ProdottiAcquistati, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/acquirenti-prodotti-lista', component: AcquirentiProdottiLista, meta: { requiresRole: ['Amministratore', 'Studio'] } },

  { path: '/uscite', component: UsciteComponent, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/videocall-list', component: VideocallList, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/videocall-list-booking', component: VideocallListBooking, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/booking-list', component: BookingsList, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/calendari-eventi', component: CalendariEventi, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/import-program-history', component: ImportProgramHistory, meta: { requiresRole: ['Amministratore'] } },
  { path: '/questionari-uid-fix', component: QuestionariUidFix, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/consulenze-tecniche-scalata', component: ConsulenzeTecnicheScalataTool, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/percorsi-non-iniziati', component: PercorsiNonIniziati, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  {
    path: '/user/:userId',
    component: UserLayout,
    props: true,
    children: [
      {
        path: '',
        redirect: (to) => ({ name: 'UserDetails', params: { userId: to.params.userId } }),
      },
      { path: 'anagrafica', name: 'UserDetails', component: UserDetails, props: true },
      { path: 'ordini', name: 'UserOrdini', component: UserOrdini, props: true },
      { path: 'comunicazioni', name: 'UserComunicazioni', component: UserComunicazioni, props: true },
      { path: 'consulenze', name: 'UserConsulenze', component: UserConsulenze, props: true },
      { path: 'documenti', name: 'UserDocumenti', component: UserDocumenti, props: true },
      { path: 'check', name: 'UserCheck', component: UserCheck, props: true },
      { path: 'checkcreate', name: 'UserCheckCreate', component: UserCheckCreate, props: true },
      {
        path: 'ticketnutrizionali',
        name: 'UsersTicketNutrizionali',
        component: UsersTicketNutrizionali,
        props: true,
        meta: { requiresRole: ['Amministratore', 'Studio'] },
      },
      { path: 'tickettecnici', name: 'UserTicketTecnici', component: UserTicketTecnici, props: true },
      { path: 'alimentazione', name: 'UserAlimentazione', component: UserAlimentazione, props: true },
      {
        path: 'allenamenti',
        name: 'UserAllenamenti',
        component: () => import('./features/allenamenti/TrainerAllenamenti.vue'),
        props: true,
        meta: { requiresAuth: true, requiresRole: ['Amministratore', 'Studio'] },
      },
      { path: 'programmi', name: 'UserProgrammi', component: UserProgrammi, props: true },
      {
        path: 'programmi/questionario',
        name: 'UserProgrammiQuestionario',
        component: UserProgrammiQuestionario,
        props: true
      },
      {
        path: 'programmi/check-finale',
        name: 'UserProgrammiCheckFinale',
        component: UserProgrammiCheckFinale,
        props: true
      },
      { path: 'sedutept', name: 'UserSedutePt', component: UserSedutePt, props: true },
    ],
  },
  { path: '/consulenze-riepilogo', name: 'UserConsulenzeRiepilogo', component: UserConsulenzeRiepilogo, props: true },

  { path: '/videocall-list', component: VideocallList, meta: { requiresRole: ['Amministratore', 'Studio'] } },
  { path: '/user', component: UserDashboard, meta: { requiresAuth: true } },
  { path: '/i-miei-allenamenti', name: 'MyTraining', component: () => import('./components/utenti/UserAllenamenti.vue'), meta: { requiresAuth: true } },
  { path: '/user-anagrafica', component: UserAnagrafica, meta: { requiresAuth: true } },
  { path: '/ticket-page', component: TicketPage, meta: { requiresAuth: true } },
  { path: '/ticket-page-tecnico', component: TicketPageTecnico, meta: { requiresAuth: true } },
  { path: '/alimentazione-page', component: AlimentazionePage, meta: { requiresAuth: true } },
  { path: '/check-storico', component: UserCheckStorico, meta: { requiresAuth: true } },
  { path: '/come-funziona', component: ComeFunzionaMobile, meta: { requiresAuth: true } },
  { path: '/servizi', name: 'UserServices', component: UserServices, meta: { requiresAuth: true } },
  { path: '/integrazione', name: 'UserIntegrazione', component: () => import('./components/utenti/UserIntegrazione.vue'), meta: { requiresAuth: true } },
  { path: '/user-programmi', component: ProgrammiUser, meta: { requiresAuth: true } },
  {
    path: '/user-programmi/questionario',
    name: 'ProgrammiUserQuestionario',
    component: ProgrammiUserQuestionario,
  },
  {
    path: '/user-programmi/check-finale',
    name: 'ProgrammiUserCheckFinale',
    component: ProgrammiUserCheckFinale,
  },

    { path: '/questionari-template', component: QuestionariTemplatesAdmin, meta: { requiresRole: ['Amministratore', 'Studio'] } },
    { path: '/questionari-users', component: QuestionariUsers, meta: { requiresRole: ['Amministratore', 'Studio'] } },
    { path: '/questionari-users-scaduti', component: QuestionariUsersScaduti, meta: { requiresRole: ['Amministratore', 'Studio'] } },
    { path: '/questionari-manuali', component: QuestionariManuali, meta: { requiresRole: ['Amministratore', 'Studio'] } },


  { path: '/create-ticket', component: CreateTicket, meta: { requiresAuth: true } },
  { path: '/create-ticket-tecnico', component: CreateTicketTecnico, meta: { requiresAuth: true } },
  { path: '/assistenzanutrizionale/conversation/:ticketId', component: AdminTicketConversation, name: 'AdminTicketConversation' },
  { path: '/assistenzatecnica/conversation/:ticketId', component: AssistenzaTecnicaConversation, name: 'AssistenzaTecnicaConversation' },
  { path: '/ricetta', component: RicettaComponent, meta: { requiresAuth: true } },
  { path: '/createusers', component: CreateUsers },
  { path: '/video-call-page', name: 'VideoCallPage', component: VideoCallPage, meta: { requiresAuth: true } },
  { path: '/video-call', name: 'VideoCall', component: VideoCall, meta: { requiresAuth: true } },
  { path: '/booking', name: 'UserBooking', component: UserBooking, meta: { requiresAuth: true } },
  { path: '/user/conversation/:ticketId', component: UserTicketConversation, name: 'UserTicketConversation', meta: { requiresAuth: true } },
  { path: '/user/conversation-tecnico/:ticketId', component: UserTicketConversationTecnico, name: 'UserTicketConversationTecnico', meta: { requiresAuth: true } },
  {
    path: '/user/:userId/conversation-tecnica/:ticketId',
    name: 'UserConversationTecnica',
    component: AssistenzaTecnicaConversation,
    props: true,
    meta: { requiresRole: ['Amministratore', 'Studio'] },
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL || '/'),
  routes
});

const resolveUserRole = async (user, acceptedRoles = []) => {
  if (!user) {
    return '';
  }

  // Il ruolo in cache è valido solo per lo stesso UID e solo se autorizza già
  // questa destinazione. Un valore provvisorio o obsoleto viene verificato sul
  // profilo Firestore prima di decidere il redirect.
  const storedRole = getStoredRoleForUser(localStorage, user.uid, acceptedRoles);
  if (storedRole) {
    return storedRole;
  }

  try {
    const db = getFirestore();
    const userDoc = await getDoc(doc(db, 'users', user.uid));
    const role = userDoc.exists() ? (userDoc.data().userRole || 'User') : 'User';
    saveStoredRole(localStorage, user.uid, role);
    return role;
  } catch (error) {
    console.error('Errore nel recupero del ruolo utente:', error);
    return '';
  }
};

// Usa il guard asincrono nel beforeEach
router.beforeEach(async (to, from, next) => {
    if (to.path.startsWith('/paypal/')) return next(); // skip guard per PayPal


  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const acceptedRoles = Array.from(new Set(to.matched.flatMap(record => (
    Array.isArray(record.meta.requiresRole) ? record.meta.requiresRole : []
  ))));
  const requiresRole = acceptedRoles.length > 0;

  // Le rotte pubbliche (incluso il login iniziale) non devono attendere
  // l'inizializzazione di Firebase Auth. Nei WebView iOS questa attesa può
  // rimanere sospesa e lasciare il router-view completamente vuoto.
  if (!requiresAuth && !requiresRole) {
    return next();
  }

  try {
    // Attendi che Firebase determini lo stato dell'utente
    const user = await getCurrentUser();

    // Se la rotta richiede autenticazione e non c'è utente, reindirizza al login
    if (requiresAuth && !user) {
      if (to.name === 'MyTraining') return next({ path: '/', query: { redirect: '/i-miei-allenamenti' } });
      return next('/');
    }

    // Se la rotta richiede un ruolo specifico, controlla quello salvato (ad esempio nel localStorage)
    if (requiresRole) {
      const userRole = await resolveUserRole(user, acceptedRoles);
      if (!userRole || !acceptedRoles.includes(userRole)) {
        return next('/noaccess');
      }
    }

    next();
  } catch (error) {
    console.error('Errore nel controllo di autenticazione:', error);
    next('/'); // In caso di errore, reindirizza al login
  }
});

export default router;
